import { GET_BOOKING_LIFECYCLE_TIMELINE, GET_BOOKING_LIFECYCLE_TIMELINE_SUCCESS, GET_BOOKING_LIFECYCLE_TIMELINE_ERROR, GET_BOOKING_LIFECYCLE_TIMELINE_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetBookingLifecycleTimeline = (state = initialState, action) => {
  switch (action.type) {
    case GET_BOOKING_LIFECYCLE_TIMELINE:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_BOOKING_LIFECYCLE_TIMELINE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_BOOKING_LIFECYCLE_TIMELINE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_BOOKING_LIFECYCLE_TIMELINE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetBookingLifecycleTimeline;
